const handlePromise = <PromiseType>(
  p: Promise<PromiseType>, 
  callback?: () => void
): Promise<[PromiseType, null] | [null, Error]> => new Promise((res, _) => {
    p.then((r: PromiseType) => res([ r, null ]))
      .catch((err: Error) => res([ null, err ]))
      .finally(() => callback ? callback() : null);
  });

export default handlePromise;